import { useState } from 'react';
import { useParams } from 'react-router';

import { Layout } from '../../../CorePackage/MainModule/components/Layout';
import { PassportGroup } from '../../../PassportGroupPackage/PassportGroupModule/PassportGroup';
import { ROUTE_KNM_MASS_DELETION } from '../../../CorePackage/MainModule/routes/routes';
import { PassportMassDeletionModal } from './PassportMassDeletionModal';

export const PassportMassDeletionGroupPage = () => {
  const { id } = useParams<{ id: string }>();
  const [isShowMassDeletionModal, setIsShowMassDeletionModal] = useState(false);

  return (
    <Layout withFooter>
      <>
        <PassportGroup
          backUrl={ROUTE_KNM_MASS_DELETION}
          onMassDeletionApply={() => setIsShowMassDeletionModal(true)}
          isShowCheckbox
        />
        {isShowMassDeletionModal && (
          <PassportMassDeletionModal
            groupId={Number.parseInt(id, 10)}
            onClose={() => setIsShowMassDeletionModal(false)}
          />
        )}
      </>
    </Layout>
  );
};
